<template>
  <div>
    <div
      class="flex flex-col items-center justify-center p-40 bg-grey-background-contrast rounded-xl border-1 border-solid border-grey-divider-subdued mb-40"
    >
      <search-outline-icon :width="40" :height="40" color="#FF0064" />
      <h2 class="text-h3 mt-16">No sitters fully match your criteria</h2>
      <p class="text-body mt-8">Try adjusting filters to see more options.</p>
    </div>
    <horizontal-divider />
    <BHPartnersList v-if="!hasBackupResults" class="mt-40" :zipCode="zip" :showHeader="false" />
  </div>
</template>

<script lang="ts">
import SearchOutlineIcon from '@/graphics/icons/SearchOutlineIcon.vue';
import HorizontalDivider from '@/components/divider/HorizontalDivider.vue';
import BHPartnersList from '@/components/bh_partners/BHPartnersList.vue';

export default {
  name: 'SearchEmptyState',
  components: {
    SearchOutlineIcon,
    HorizontalDivider,
    BHPartnersList,
  },
  props: {
    zip: {
      type: String,
      default: '',
    },
    hasBackupResults: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
